/* 

  HEADS UP! THIS IS A GENERATED FILE!
  
  Changes done in this file will be overwritten on next generation from the code generator.

*/
import axios from 'axios';
import { arrayMerge } from 'flaivy-react/utils/array-helper';
import _ from 'lodash';
import getAxiosInstance from '../../../config/api';
import datalayer from '../../../datalayer';

export const ACTION_TYPES = {
  CHANGE_ORIGIN_ORDER: 'ORDER/CHANGE_ORIGIN_ORDER',
  PLACE_ORDER_ORDER: 'ORDER/PLACE_ORDER_ORDER',
  SEND_TO_WAREHOUSE_ORDER: 'ORDER/SEND_TO_WAREHOUSE_ORDER',
  CHANGE_DELIVERY_DATE_ORDER: 'ORDER/CHANGE_DELIVERY_DATE_ORDER',
  START_WAREHOUSE_PROCESSING_ORDER: 'ORDER/START_WAREHOUSE_PROCESSING_ORDER',
  SET_IN_DRAFT_STATE_ORDER: 'ORDER/SET_IN_DRAFT_STATE_ORDER',
  SET_IN_WAITING_FOR_RESTOCK_STATE_ORDER:
    'ORDER/SET_IN_WAITING_FOR_RESTOCK_STATE_ORDER',
  SET_IN_WAITING_FOR_ADVANCE_PAYMENT_STATE_ORDER:
    'ORDER/SET_IN_WAITING_FOR_ADVANCE_PAYMENT_STATE_ORDER',
  SET_EMCS_INFORMATION_ORDER: 'ORDER/SET_EMCS_INFORMATION_ORDER',
  MARK_AS_READY_ORDER: 'ORDER/MARK_AS_READY_ORDER',
  SET_EMAIL_SENT_ORDER: 'ORDER/SET_EMAIL_SENT_ORDER',
  SHIP_ORDER_ORDER: 'ORDER/SHIP_ORDER_ORDER',
  DELIVER_ORDER_ORDER: 'ORDER/DELIVER_ORDER_ORDER',
  INVOICE_ORDER_ORDER: 'ORDER/INVOICE_ORDER_ORDER',
  CANCEL_ORDER: 'ORDER/CANCEL_ORDER',
  WRITE_ORDER_ORDER: 'ORDER/WRITE_ORDER_ORDER',
  WRITE_SYSTEMBOLAGET_ORDER_ORDER: 'ORDER/WRITE_SYSTEMBOLAGET_ORDER_ORDER',
  SET_TRACKING_CODE_ORDER: 'ORDER/SET_TRACKING_CODE_ORDER',
  FORTNOX_ORDER_ORDER: 'ORDER/FORTNOX_ORDER_ORDER',
  DEVIATION_IN_DELIVERY_ORDER: 'ORDER/DEVIATION_IN_DELIVERY_ORDER',
  ENSURE_INVARIANTS_ORDER: 'ORDER/ENSURE_INVARIANTS_ORDER',
  PUSH_TO_STATE_ORDER: 'ORDER/PUSH_TO_STATE_ORDER',
  MERGE_ORDER_ORDER: 'ORDER/MERGE_ORDER_ORDER',
  APPROVE_DROPSHIP_ORDER_ORDER: 'ORDER/APPROVE_DROPSHIP_ORDER_ORDER',
  SHIP_DROPSHIP_ORDER_ORDER: 'ORDER/SHIP_DROPSHIP_ORDER_ORDER',
  PUBLIC_CANCEL_ORDER_ORDER: 'ORDER/PUBLIC_CANCEL_ORDER_ORDER',
  PUBLIC_APPROVE_ORDER_ORDER: 'ORDER/PUBLIC_APPROVE_ORDER_ORDER',
  PUBLIC_CHANGE_ORDER_ORDER: 'ORDER/PUBLIC_CHANGE_ORDER_ORDER',
  PUBLIC_GET_ORDER_ORDER: 'ORDER/PUBLIC_GET_ORDER_ORDER',
  CHANGE_ORDER_FULLFILLMENT_CENTER_ORDER:
    'ORDER/CHANGE_ORDER_FULLFILLMENT_CENTER_ORDER',
  CHANGE_ORDER_FULLFILLMENT_CENTER_TEMPORARY_SOLUTION_FOR_SUPER_ORDER:
    'ORDER/CHANGE_ORDER_FULLFILLMENT_CENTER_TEMPORARY_SOLUTION_FOR_SUPER_ORDER',
  CONNECT_SUPPLIER_CUSTOMER_TO_ORDER_ORDER:
    'ORDER/CONNECT_SUPPLIER_CUSTOMER_TO_ORDER_ORDER',
  UPSERT_ORDER_WITH_QUANTITIES_PER_COLLI_ORDER:
    'ORDER/UPSERT_ORDER_WITH_QUANTITIES_PER_COLLI_ORDER',
  UPSERT_ORDER: 'ORDER/UPSERT_ORDER',
  UPSERT_WHEN_EMPTY_ORDER: 'ORDER/UPSERT_WHEN_EMPTY_ORDER',
  UPDATE_WHEN_EMPTY_ORDER: 'ORDER/UPDATE_WHEN_EMPTY_ORDER',
  UPDATE_ORDER: 'ORDER/UPDATE_ORDER',
  FETCH_ORDER: 'ORDER/FETCH_ORDER',
  SET_ORDER_LIST: 'SET_ORDER_LIST',
  SET_ORDER_QUERY: 'ORDER/SET_ORDER_QUERY',
};

let cancelTokenSource = null;

export const setQuery = query => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.SET_ORDER_QUERY,
    payload: { query },
  });
};

export async function fetchMoreAndReturnNewState(newQuery, state, req) {
  const { entities, currentPage, hasMore, sort } = state;

  if (cancelTokenSource) {
    cancelTokenSource.cancel();
  }

  const page = currentPage + 1;

  if (!hasMore && page !== 1) return state;

  cancelTokenSource = axios.CancelToken.source();
  const query = { query: newQuery, page, sort, searchString: state.search };
  const options = { cancelToken: cancelTokenSource.token };
  const responseData = await datalayer.order.list(query, req, options);
  if (responseData === undefined) {
    //canceled request
    return undefined;
  }

  cancelTokenSource = null;
  const recievedEntities = responseData.rows;
  const newHasMore = responseData.page < responseData.totalPages;
  let newEntities = [];
  if (responseData.page === 1) {
    newEntities = recievedEntities;
  } else {
    newEntities = arrayMerge(recievedEntities, entities);
  }
  return {
    query: newQuery,
    hasMore: newHasMore,
    total: responseData.total,
    entities: newEntities,
    currentPage: responseData.page,
    search: state.search,
    sort: _.get(newQuery, 'sort', sort),
  };
}

export const refreshListOnQueryDiff =
  (newListState, req) => async (dispatch, getState) => {
    let payload = newListState;
    const currentState = _.get(getState(), 'orderList');
    const currentQuery = currentState.query;
    if (!_.isEqual(newListState.query, currentQuery)) {
      payload = await fetchMoreAndReturnNewState(
        newListState.query,
        { ...currentState, ...newListState, currentPage: 0 },
        req,
      );
    }
    if (!payload) {
      return;
    } // cancelled loading, dont update the store
    await dispatch({
      type: ACTION_TYPES.SET_ORDER_LIST,
      payload,
    });
  };

export const setSortOrder = sort => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.SET_ORDER_LIST,
    payload: { sort },
  });
};

export const setListStore = newListState => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.SET_ORDER_LIST,
    payload: newListState,
  });
};

export const resolve = async (id, req) => {
  return await datalayer.order.get({ id }, req);
};

export const get = (req, id) => dispatch => {
  return dispatch({
    type: ACTION_TYPES.FETCH_ORDER,
    payload: datalayer.order.get({ id }, req),
  });
};

export const changeOrigin = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.changeOrigin',
  });

export const placeOrder = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.placeOrder',
  });

export const sendToWarehouse = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.sendToWarehouse',
  });

export const changeDeliveryDate = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.changeDeliveryDate',
  });

export const startWarehouseProcessing = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.startWarehouseProcessing',
  });

export const setInDraftState = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.setInDraftState',
  });

export const setInWaitingForRestockState = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.setInWaitingForRestockState',
  });

export const setInWaitingForAdvancePaymentState = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.setInWaitingForAdvancePaymentState',
  });

export const setEmcsInformation = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.setEMCSInformation',
  });

export const markAsReady = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.markAsReady',
  });

export const setEmailSent = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.setEmailSent',
  });

export const shipOrder = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.shipOrder',
  });

export const deliverOrder = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.deliverOrder',
  });

export const invoiceOrder = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.invoiceOrder',
  });

export const cancel = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.cancel',
  });

export const writeOrder = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.writeOrder',
  });

export const writeSystembolagetOrder = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.writeSystembolagetOrder',
  });

export const setTrackingCode = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.setTrackingCode',
  });

export const fortnoxOrder = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.fortnoxOrder',
  });

export const deviationInDelivery = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.deviationInDelivery',
  });

export const ensureInvariants = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.ensureInvariants',
  });

export const pushToState = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.pushToState',
  });

export const mergeOrder = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.mergeOrder',
  });

export const approveDropshipOrder = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.approveDropshipOrder',
  });

export const shipDropshipOrder = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.shipDropshipOrder',
  });

export const publicCancelOrder = actionParams =>
  getAxiosInstance().post('public/cancelOrder', { ...actionParams });

export const publicApproveOrder = actionParams =>
  getAxiosInstance().post('public/approveOrder', { ...actionParams });

export const publicChangeOrder = actionParams =>
  getAxiosInstance().post('public/changeOrder', { ...actionParams });

export const publicGetOrder = actionParams =>
  getAxiosInstance().post('public/orders', { ...actionParams });

export const changeOrderFullfillmentCenter = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.changeOrderFullfillmentCenter',
  });

export const changeOrderFullfillmentCenterTemporarySolutionForSuper =
  actionParams =>
    getAxiosInstance().post('actions', {
      payload: actionParams,
      action: 'v1.order.changeOrderFullfillmentCenterTemporarySolutionForSuper',
    });

export const connectSupplierCustomerToOrder = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.connectSupplierCustomerToOrder',
  });

export const upsertOrderWithQuantitiesPerColli = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.upsertOrderWithQuantitiesPerColli',
  });

export const upsert = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.upsert',
  });

export const upsertWhenEmpty = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.upsertWhenEmpty',
  });

export const updateWhenEmpty = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.updateWhenEmpty',
  });

export const update = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.order.update',
  });
